import { Quote } from "lucide-react";
import "../css/QuoteCard.css";
export default function QuoteCard() {
  return (
    <div className="quote-card">
      <Quote className="quote-icon" />
      <p className="quote-text">
        En la Universidad Técnica Particular de Loja asumimos el desafío de
        consolidar un ecosistema universitario internacionalizado, creativo,
        innovador y sostenible, que permita a la UTPL ser una institución
        pertinente y transformadora, con un impacto tangible en la sociedad.
      </p>
      <span className="quote-author">
        Dr. Santiago Acosta, Rector UTPL
      </span>
    </div>
  );
}